import heroImage from '@/assets/images/works/projects/hyperdrive/hyperdrive-logo.png'
import compareLeft from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-left.mp4'
import compareRight from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-right.png'

const framesModules = import.meta.glob(
  '/src/assets/images/works/projects/hyperdrive/hero-frames/*.png',
  { eager: true, import: 'default' }
)
const heroFrames = Object.keys(framesModules)
  .sort()
  .map((path) => framesModules[path])

export default {
  meta: {
    // ... (content implied same)
    title: 'HYPERDRIVE',
    headline: 'Into the <br> <span class="text-electric-purple">Hyperspace.</span>',
    label: 'Case Study 02',
    description:
      'Un portfolio inmersivo con temática Sci-Fi, desarrollado con Vue 3 y animación de velocidad luz.',
    chips: [
      { text: 'Portfolio', dotColor: 'bg-electric-purple' },
      { text: 'Creative Dev', dotColor: 'bg-blue-500' },
      { text: '2024' },
    ],
    heroImage: heroImage,
    heroFrames: heroFrames,
  },
  sidebar: {
    title: 'Índice',
    meta: [
      { label: 'Cliente', value: 'Personal Project' },
      { label: 'Tipo', value: 'Web Portfolio' },
      { label: 'Rol', value: 'Creative Developer' },
      { label: 'Stack', value: 'Vue 3, Tailwind CSS, GSAP, Canvas' },
      { label: 'Año', value: '2024' },
    ],
    cta: 'View Live Site',
    ctaLink: 'https://hyperdrive.juanlias.com',
    repoLink: 'https://github.com/juanlias/hyperdrive-portfolio',
  },
  sections: {
    overview: {
      id: 'overview',
      menuLabel: 'Overview',
      title: 'El proyecto en breve',
      highlight:
        'Hyperdrive redefine la marca personal combinando la potencia de Vue 3, Tailwind CSS y GSAP en una interfaz de ciencia ficción inspirada en Star Wars.',
      cards: [
        {
          title: 'Hyperspace Intro',
          text: 'Simulación de viaje espacial con Canvas que genera compromiso inmediato desde el primer segundo.',
        },
        {
          title: 'Comando',
          text: 'Panel de control retro-futurista con estética Glassmorphism, bordes de neón y feedback háptico visual.',
        },
      ],
    },
    enfoque: {
      id: 'enfoque',
      menuLabel: 'Concepto',
      label: 'Sistema Kyber',
      title: 'Personalización Total',
      description:
        'Inspirado en los sables de luz, el sistema <strong>Cristal Kyber</strong> permite cambiar la paleta de colores en tiempo real (Ilum, Adegan, Hurrikaine) mediante barridos holográficos y cascadas de energía.',
      tags: ['Glassmorphism', 'Kyber Crystals', 'Holographic UI'],
    },
    problema: {
      id: 'problema',
      menuLabel: 'Performance',
      title: 'El Desafío',
      description:
        'Crear un factor "Wow" visual sin sacrificar la velocidad de carga. Balancear una interfaz experimental con sistemas complejos de accesibilidad y soporte multilingüe (incluyendo Shavian).',
      stats: [
        { value: '5', label: 'Temas' },
        { value: '4', label: 'Idiomas' },
      ],
    },
    transformacion: {
      id: 'antesdespues',
      menuLabel: 'Comparativa',
      title: 'Calibración Visual',
      beforeLabel: 'System Standby',
      afterLabel: 'Holographic Mode',
      instruction: 'Arrastra para inicializar',
      beforeImage: compareLeft,
      afterImage: compareRight,
    },
    tecnologia: {
      id: 'tecnologia',
      menuLabel: 'Tech Stack',
      title: 'Ingeniería',
      categories: [
        { name: 'Core', items: ['Vue 3', 'Vite', 'Vue I18n'] },
        { name: 'Animation', items: ['GSAP', 'Canvas API', 'WebGL'] },
        { name: 'Styles', items: ['Tailwind CSS', 'HugeIcons'] },
      ],
    },
  },
  footer: {
    prev: { label: 'Previous Case', title: 'FinanzaFlow', link: '/works/finanza' },
    next: null,
  },
}
